import { Outlet } from 'react-router-dom';
import { notification } from 'antd';
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { TestBuilderProvider } from './Manage/context/TestBuilderContext';
import useSettingsState from '../../atoms/variables';
import useTemplateState from '../../../Template/atoms/variables';
import { getAllCategories } from './Manage/services/test.service.ts';

const TestConfigurationOutlet = () => {
  const [notificationApi, contextHolder] = notification.useNotification();

  const { instance } = useMsal();
  const { categories, setCategories } = useSettingsState();
  const { setPendingApiCalls } = useTemplateState();

  useEffect(() => {
    if (categories?.length === 0) {
      triggerApiCalls();
    }
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['getAllCategories']));

      const response = await getAllCategories(instance);
      setCategories(response);
    } catch (err) {
      notificationApi.error({
        message: 'Falha de comunicação com o banco de dados',
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== 'getAllCategories'));
    }
  };

  return (
    <TestBuilderProvider>
      {contextHolder}
      <Outlet />
    </TestBuilderProvider>
  );
};

export default TestConfigurationOutlet;
